'use client';

import { useRouter } from 'next/navigation';
import { useStore } from '@/store/store';
import { getPlatformBridge } from '@/logic/bridges';
import { ROUTES } from '@/utils/constants';
import { store, STORAGE_KEYS } from '@/utils/storage';

type UseSwjRulesNavigationParams = {
    openInBrowser: boolean;
    rulesPath?: string;
    navigationSource: 'home' | 'category';
};

export const useSwjRulesNavigation = ({ openInBrowser, rulesPath, navigationSource }: UseSwjRulesNavigationParams) => {
    const router = useRouter();
    const handleShowLoading = useStore((state) => state.loading.handleShowLoading);

    const handleRulesClick = () => {
        store({ key: STORAGE_KEYS.NAVIGATION_SOURCE, value: navigationSource }, 'local');

        if (openInBrowser && rulesPath) {
            const platformBridge = getPlatformBridge();
            platformBridge.exec('redirectToBrowser', rulesPath);
            platformBridge.exec('openExternalWebView', rulesPath);
        } else {
            handleShowLoading();
            router.push(ROUTES.SITE_WIDE_JACKPOT_RULES);
        }
    };

    const handleInfoButtonClick = () => {
        if (!openInBrowser) {
            store({ key: STORAGE_KEYS.NAVIGATION_SOURCE, value: navigationSource }, 'local');
        }
    };

    return {
        handleRulesClick,
        handleInfoButtonClick
    };
};
